import { useMemo } from "react";
import { FolderTreeItem } from "../../folderTree";
import { useCurrentFolder } from "../../../components/FolderContext";
import { useUserAccountRole } from "../useUserAccountRole";

export interface Response {
  canBulkChangeOwner: boolean;
}

export const defaultResponse: Response = {
  canBulkChangeOwner: false,
};

interface Input {
  // Optionally include a folder to avoid using the context
  folder?: FolderTreeItem | null;
}

export function useBulkZapActionPermissions({
  folder: folderArgument,
}: Input): Response {
  // grab the current folder from the nearest FolderContext.Provider
  const folderContext = useCurrentFolder();
  const folder = folderArgument || folderContext;

  const folderIsShared = !!folder?.isShared;

  const { isAccountOwner, isSuperAdmin, isAdmin } = useUserAccountRole();

  const canBulkChangeOwner = useMemo(() => {
    if (folderIsShared && (isAccountOwner || isSuperAdmin || isAdmin))
      return true;
    return false;
  }, [folderIsShared, isAccountOwner, isSuperAdmin, isAdmin]);

  return {
    canBulkChangeOwner,
  };
}
